import { useMutation } from 'react-query';

import { binderManagementFileInputAxios } from '../../binderManagement.api';
import { useHandleError } from '../../binderManagement.utils';

export const useValidateBDX = () => {
  const handleError = useHandleError({
    file: 'binderManagement.bdx.mutation.useValidateBDX',
    warning: 'notification.bdx.validateFail',
  });

  return useMutation(
    async ({ mappings, requestId, rowNumber }) => {
      const data = await binderManagementFileInputAxios.post('validate', { mappings, requestId, rowNumber });

      return data;
    },
    {
      onError: handleError,
    }
  );
};
